import { __decorate } from 'tslib';
import * as i6 from '@angular/cdk/a11y';
import { A11yModule } from '@angular/cdk/a11y';
import * as i4 from '@angular/cdk/overlay';
import { OverlayModule } from '@angular/cdk/overlay';
import { DOCUMENT, NgClass, NgStyle } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Directive, Host, Optional, Input, Output, ElementRef, Component, ChangeDetectionStrategy, ViewEncapsulation, Inject, ViewChildren, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, first, finalize } from 'rxjs/operators';
import * as i9 from 'ng-zorro-antd/button';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { zoomBigMotion } from 'ng-zorro-antd/core/animation';
import * as i2 from 'ng-zorro-antd/core/config';
import { WithConfig } from 'ng-zorro-antd/core/config';
import * as i1 from 'ng-zorro-antd/core/no-animation';
import { NzNoAnimationDirective } from 'ng-zorro-antd/core/no-animation';
import * as i7 from 'ng-zorro-antd/core/outlet';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';
import * as i5 from 'ng-zorro-antd/core/overlay';
import { NzOverlayModule } from 'ng-zorro-antd/core/overlay';
import { InputBoolean, wrapIntoObservable } from 'ng-zorro-antd/core/util';
import * as i12 from 'ng-zorro-antd/i18n';
import { NzI18nModule } from 'ng-zorro-antd/i18n';
import * as i8 from 'ng-zorro-antd/icon';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTooltipBaseDirective, NzToolTipComponent } from 'ng-zorro-antd/tooltip';
import * as i3 from '@angular/cdk/bidi';
import * as i10 from 'ng-zorro-antd/core/transition-patch';
import * as i11 from 'ng-zorro-antd/core/wave';
const _c0 = ["okBtn"];
const _c1 = ["cancelBtn"];
function NzPopconfirmComponent_ng_template_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "span", 14);
    i0.ɵɵelementEnd();
  }
}
function NzPopconfirmComponent_ng_template_0_ng_container_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const icon_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzType", icon_r3 || "exclamation-circle");
  }
}
function NzPopconfirmComponent_ng_template_0_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NzPopconfirmComponent_ng_template_0_ng_container_7_ng_container_1_Template, 2, 1, "ng-container", 10);
    i0.ɵɵelementStart(2, "div", 15);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r3.nzIcon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.nzTitle);
  }
}
function NzPopconfirmComponent_ng_template_0_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.nzCancelText, " ");
  }
}
function NzPopconfirmComponent_ng_template_0_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "nzI18n");
  }
  if (rf & 2) {
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, "Modal.cancelText"), " ");
  }
}
function NzPopconfirmComponent_ng_template_0_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.nzOkText, " ");
  }
}
function NzPopconfirmComponent_ng_template_0_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "nzI18n");
  }
  if (rf & 2) {
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, "Modal.okText"), " ");
  }
}
function NzPopconfirmComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5);
    i0.ɵɵtemplate(2, NzPopconfirmComponent_ng_template_0_Conditional_2_Template, 2, 0, "div", 6);
    i0.ɵɵelementStart(3, "div", 7)(4, "div")(5, "div", 8)(6, "div", 9);
    i0.ɵɵtemplate(7, NzPopconfirmComponent_ng_template_0_ng_container_7_Template, 4, 2, "ng-container", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 11)(9, "button", 12, 1);
    i0.ɵɵlistener("click", function NzPopconfirmComponent_ng_template_0_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onCancel());
    });
    i0.ɵɵtemplate(11, NzPopconfirmComponent_ng_template_0_Conditional_11_Template, 1, 1)(12, NzPopconfirmComponent_ng_template_0_Conditional_12_Template, 2, 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "button", 13, 2);
    i0.ɵɵlistener("click", function NzPopconfirmComponent_ng_template_0_Template_button_click_13_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onConfirm());
    });
    i0.ɵɵtemplate(15, NzPopconfirmComponent_ng_template_0_Conditional_15_Template, 1, 1)(16, NzPopconfirmComponent_ng_template_0_Conditional_16_Template, 2, 3);
    i0.ɵɵelementEnd()()()()()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("ant-popover-rtl", ctx_r3.dir === "rtl");
    i0.ɵɵproperty("cdkTrapFocusAutoCapture", ctx_r3.nzAutoFocus !== null)("ngClass", ctx_r3._classMap)("ngStyle", ctx_r3.nzOverlayStyle)("@.disabled", !!(ctx_r3.noAnimation == null ? null : ctx_r3.noAnimation.nzNoAnimation))("nzNoAnimation", ctx_r3.noAnimation == null ? null : ctx_r3.noAnimation.nzNoAnimation)("@zoomBigMotion", "active");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(2, ctx_r3.nzPopconfirmShowArrow ? 2 : -1);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r3.nzTitle);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("nzSize", "small");
    i0.ɵɵattribute("cdkFocusInitial", ctx_r3.nzAutoFocus === "cancel" || null);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(11, ctx_r3.nzCancelText ? 11 : 12);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("nzSize", "small")("nzType", ctx_r3.nzOkType !== "danger" ? ctx_r3.nzOkType : "primary")("nzDanger", ctx_r3.nzOkDanger || ctx_r3.nzOkType === "danger")("nzLoading", ctx_r3.confirmLoading);
    i0.ɵɵattribute("cdkFocusInitial", ctx_r3.nzAutoFocus === "ok" || null);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(15, ctx_r3.nzOkText ? 15 : 16);
  }
}
const NZ_CONFIG_MODULE_NAME = 'popconfirm';
let NzPopconfirmDirective = /*#__PURE__*/(() => {
  class NzPopconfirmDirective extends NzTooltipBaseDirective {
    getProxyPropertyMap() {
      return {
        nzOkText: ['nzOkText', () => this.nzOkText],
        nzOkType: ['nzOkType', () => this.nzOkType],
        nzOkDanger: ['nzOkDanger', () => this.nzOkDanger],
        nzCancelText: ['nzCancelText', () => this.nzCancelText],
        nzBeforeConfirm: ['nzBeforeConfirm', () => this.nzBeforeConfirm],
        nzCondition: ['nzCondition', () => this.nzCondition],
        nzIcon: ['nzIcon', () => this.nzIcon],
        nzPopconfirmShowArrow: ['nzPopconfirmShowArrow', () => this.nzPopconfirmShowArrow],
        nzPopconfirmBackdrop: ['nzBackdrop', () => this.nzPopconfirmBackdrop],
        nzAutoFocus: ['nzAutoFocus', () => this.nzAutofocus],
        ...super.getProxyPropertyMap()
      };
    }
    constructor(elementRef, hostView, renderer, noAnimation, nzConfigService) {
      super(elementRef, hostView, renderer, noAnimation, nzConfigService);
      this._nzModuleName = NZ_CONFIG_MODULE_NAME;
      this.trigger = 'click';
      this.placement = 'top';
      this.nzCondition = false;
      this.nzPopconfirmShowArrow = true;
      this.nzPopconfirmBackdrop = false;
      this.nzAutofocus = null;
      // eslint-disable-next-line @angular-eslint/no-output-rename
      this.visibleChange = new EventEmitter();
      this.nzOnCancel = new EventEmitter();
      this.nzOnConfirm = new EventEmitter();
      this.componentRef = this.hostView.createComponent(NzPopconfirmComponent);
    }
    /**
     * @override
     */
    createComponent() {
      super.createComponent();
      this.component.nzOnCancel.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.nzOnCancel.emit();
      });
      this.component.nzOnConfirm.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.nzOnConfirm.emit();
      });
    }
    static {
      this.ɵfac = function NzPopconfirmDirective_Factory(t) {
        return new (t || NzPopconfirmDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1.NzNoAnimationDirective, 9), i0.ɵɵdirectiveInject(i2.NzConfigService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NzPopconfirmDirective,
        selectors: [["", "nz-popconfirm", ""]],
        hostVars: 2,
        hostBindings: function NzPopconfirmDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("ant-popover-open", ctx.visible);
          }
        },
        inputs: {
          arrowPointAtCenter: [i0.ɵɵInputFlags.None, "nzPopconfirmArrowPointAtCenter", "arrowPointAtCenter"],
          title: [i0.ɵɵInputFlags.None, "nzPopconfirmTitle", "title"],
          directiveTitle: [i0.ɵɵInputFlags.None, "nz-popconfirm", "directiveTitle"],
          trigger: [i0.ɵɵInputFlags.None, "nzPopconfirmTrigger", "trigger"],
          placement: [i0.ɵɵInputFlags.None, "nzPopconfirmPlacement", "placement"],
          origin: [i0.ɵɵInputFlags.None, "nzPopconfirmOrigin", "origin"],
          mouseEnterDelay: [i0.ɵɵInputFlags.None, "nzPopconfirmMouseEnterDelay", "mouseEnterDelay"],
          mouseLeaveDelay: [i0.ɵɵInputFlags.None, "nzPopconfirmMouseLeaveDelay", "mouseLeaveDelay"],
          overlayClassName: [i0.ɵɵInputFlags.None, "nzPopconfirmOverlayClassName", "overlayClassName"],
          overlayStyle: [i0.ɵɵInputFlags.None, "nzPopconfirmOverlayStyle", "overlayStyle"],
          visible: [i0.ɵɵInputFlags.None, "nzPopconfirmVisible", "visible"],
          nzOkText: "nzOkText",
          nzOkType: "nzOkType",
          nzOkDanger: "nzOkDanger",
          nzCancelText: "nzCancelText",
          nzBeforeConfirm: "nzBeforeConfirm",
          nzIcon: "nzIcon",
          nzCondition: "nzCondition",
          nzPopconfirmShowArrow: "nzPopconfirmShowArrow",
          nzPopconfirmBackdrop: "nzPopconfirmBackdrop",
          nzAutofocus: "nzAutofocus"
        },
        outputs: {
          visibleChange: "nzPopconfirmVisibleChange",
          nzOnCancel: "nzOnCancel",
          nzOnConfirm: "nzOnConfirm"
        },
        exportAs: ["nzPopconfirm"],
        standalone: true,
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  __decorate([InputBoolean()], NzPopconfirmDirective.prototype, "arrowPointAtCenter", void 0);
  __decorate([InputBoolean()], NzPopconfirmDirective.prototype, "nzOkDanger", void 0);
  __decorate([InputBoolean()], NzPopconfirmDirective.prototype, "nzCondition", void 0);
  __decorate([InputBoolean()], NzPopconfirmDirective.prototype, "nzPopconfirmShowArrow", void 0);
  __decorate([WithConfig()], NzPopconfirmDirective.prototype, "nzPopconfirmBackdrop", void 0);
  __decorate([WithConfig()], NzPopconfirmDirective.prototype, "nzAutofocus", void 0);
  return NzPopconfirmDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NzPopconfirmComponent = /*#__PURE__*/(() => {
  class NzPopconfirmComponent extends NzToolTipComponent {
    constructor(cdr, elementRef, directionality, document, noAnimation) {
      super(cdr, directionality, noAnimation);
      this.elementRef = elementRef;
      this.nzCondition = false;
      this.nzPopconfirmShowArrow = true;
      this.nzOkType = 'primary';
      this.nzOkDanger = false;
      this.nzAutoFocus = null;
      this.nzBeforeConfirm = null;
      this.nzOnCancel = new Subject();
      this.nzOnConfirm = new Subject();
      this._trigger = 'click';
      this.elementFocusedBeforeModalWasOpened = null;
      this._prefix = 'ant-popover';
      this.confirmLoading = false;
      this.document = document;
    }
    ngOnDestroy() {
      super.ngOnDestroy();
      this.nzOnCancel.complete();
      this.nzOnConfirm.complete();
    }
    /**
     * @override
     */
    show() {
      if (!this.nzCondition) {
        this.capturePreviouslyFocusedElement();
        super.show();
      } else {
        this.onConfirm();
      }
    }
    hide() {
      super.hide();
      this.restoreFocus();
    }
    handleConfirm() {
      this.nzOnConfirm.next();
      super.hide();
    }
    onCancel() {
      this.nzOnCancel.next();
      super.hide();
    }
    onConfirm() {
      if (this.nzBeforeConfirm) {
        const observable = wrapIntoObservable(this.nzBeforeConfirm()).pipe(first());
        this.confirmLoading = true;
        observable.pipe(finalize(() => {
          this.confirmLoading = false;
          this.cdr.markForCheck();
        }), takeUntil(this.nzVisibleChange), takeUntil(this.destroy$)).subscribe(value => {
          if (value) {
            this.handleConfirm();
          }
        });
      } else {
        this.handleConfirm();
      }
    }
    capturePreviouslyFocusedElement() {
      if (this.document) {
        this.elementFocusedBeforeModalWasOpened = this.document.activeElement;
      }
    }
    restoreFocus() {
      const toFocus = this.elementFocusedBeforeModalWasOpened;
      // We need the extra check, because IE can set the `activeElement` to null in some cases.
      if (toFocus && typeof toFocus.focus === 'function') {
        const activeElement = this.document.activeElement;
        const element = this.elementRef.nativeElement;
        if (!activeElement || activeElement === this.document.body || activeElement === element || element.contains(activeElement)) {
          toFocus.focus();
        }
      }
    }
    static {
      this.ɵfac = function NzPopconfirmComponent_Factory(t) {
        return new (t || NzPopconfirmComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i3.Directionality, 8), i0.ɵɵdirectiveInject(DOCUMENT, 8), i0.ɵɵdirectiveInject(i1.NzNoAnimationDirective, 9));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzPopconfirmComponent,
        selectors: [["nz-popconfirm"]],
        viewQuery: function NzPopconfirmComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5, ElementRef);
            i0.ɵɵviewQuery(_c1, 5, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.okBtn = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cancelBtn = _t);
          }
        },
        exportAs: ["nzPopconfirmComponent"],
        standalone: true,
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 6,
        consts: [["overlay", "cdkConnectedOverlay"], ["cancelBtn", ""], ["okBtn", ""], ["cdkConnectedOverlay", "", "nzConnectedOverlay", "", 3, "overlayOutsideClick", "detach", "positionChange", "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayOrigin", "cdkConnectedOverlayPositions", "cdkConnectedOverlayOpen", "cdkConnectedOverlayPush", "nzArrowPointAtCenter"], ["cdkTrapFocus", "", 1, "ant-popover", 3, "cdkTrapFocusAutoCapture", "ngClass", "ngStyle", "nzNoAnimation"], [1, "ant-popover-content"], [1, "ant-popover-arrow"], [1, "ant-popover-inner"], [1, "ant-popover-inner-content"], [1, "ant-popover-message"], [4, "nzStringTemplateOutlet"], [1, "ant-popover-buttons"], ["nz-button", "", 3, "click", "nzSize"], ["nz-button", "", 3, "click", "nzSize", "nzType", "nzDanger", "nzLoading"], [1, "ant-popover-arrow-content"], [1, "ant-popover-message-title"], ["nz-icon", "", "nzTheme", "fill", 3, "nzType"]],
        template: function NzPopconfirmComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, NzPopconfirmComponent_ng_template_0_Template, 17, 19, "ng-template", 3, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵlistener("overlayOutsideClick", function NzPopconfirmComponent_Template_ng_template_overlayOutsideClick_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClickOutside($event));
            })("detach", function NzPopconfirmComponent_Template_ng_template_detach_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.hide());
            })("positionChange", function NzPopconfirmComponent_Template_ng_template_positionChange_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onPositionChange($event));
            });
          }
          if (rf & 2) {
            i0.ɵɵproperty("cdkConnectedOverlayHasBackdrop", ctx.nzBackdrop)("cdkConnectedOverlayOrigin", ctx.origin)("cdkConnectedOverlayPositions", ctx._positions)("cdkConnectedOverlayOpen", ctx._visible)("cdkConnectedOverlayPush", ctx.cdkConnectedOverlayPush)("nzArrowPointAtCenter", ctx.nzArrowPointAtCenter);
          }
        },
        dependencies: [OverlayModule, i4.CdkConnectedOverlay, NzOverlayModule, i5.NzConnectedOverlayDirective, A11yModule, i6.CdkTrapFocus, NgClass, NgStyle, NzNoAnimationDirective, NzOutletModule, i7.NzStringTemplateOutletDirective, NzIconModule, i8.NzIconDirective, NzButtonModule, i9.NzButtonComponent, i10.ɵNzTransitionPatchDirective, i11.NzWaveDirective, NzI18nModule, i12.NzI18nPipe],
        encapsulation: 2,
        data: {
          animation: [zoomBigMotion]
        },
        changeDetection: 0
      });
    }
  }
  return NzPopconfirmComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzPopconfirmModule = /*#__PURE__*/(() => {
  class NzPopconfirmModule {
    static {
      this.ɵfac = function NzPopconfirmModule_Factory(t) {
        return new (t || NzPopconfirmModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NzPopconfirmModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [NzPopconfirmComponent]
      });
    }
  }
  return NzPopconfirmModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzPopconfirmComponent, NzPopconfirmDirective, NzPopconfirmModule };
